import styled from "styled-components";

export const MainStyled = styled.div`
  display: flex;
  flex-direction: column;
  /* background-color: #f6f7f9; */
  background-image: url("../London_Map.jpg");
  padding: 14px;
  /* border: 2px solid black; */
  box-shadow: 0 4px 10px 0 rgba(53, 58, 80, 0.25);
  border-radius: 18px;
`;
export const DisableVehivle = styled.div`
  background-color: #90adc6;
  width: 312px;
  border-radius: 18px;
  padding: 6px 11px 6px 12px;
  color: #fff;
`;
export const EnableVehivle = styled.div`
  width: 312px;
  /* padding: 6px 11px 6px 12px; */
  padding:6px;
  border-radius: 18px;
  box-shadow: 0 4px 10px 0 rgba(255, 191, 29, 0.25);
  background-color: #ffbf1d;
  color: #353a50;
  margin-top: 24px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  margin-top: 10px;
`;
export const BtnStyled = styled.div`
  display: flex;
  align-items: center;
  border-radius: 12px;
  background-color: #2a2e43;
  padding: 2px;
  text-align: center;
  color: #ffbf1d;
  margin-top: 14px;
`;
